/* eslint-disable */
export default {
  loading: 'Ladataan...',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
